export const Suspended = () => {
  return (
    <div className="p-2">
      {/* Suspended banner */}
      <div className="px-6 py-5 bg-[#64748B1A]">
        {/* Top row */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-3">
            {/* Suspended icon */}
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#64748B"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
            </svg>
            <span className="text-[#434343] text-[24px] font-bold">
              Suspended
            </span>
          </div>
        </div>

        {/* Description */}
        <p className="text-[#434343F2] text-sm leading-relaxed font-medium pl-8">
          Your account is suspended due to non-payment. You can reactivate it
          anytime within one year.
        </p>
      </div>
      <div className="border border-[#E8E8E8] p-3 rounded-md mt-5">
        <div className="flex flex-row justify-between">
          <div className="flex-1">
            <span className="text-2xl text-[#292D32] font-bold">
              Professional Plan
            </span>
            <div className="inline-block mb-1 ml-2">
              <div className="inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full bg-[#292D321A] text-[#292D32] w-fit">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5Z"
                    fill="#64748B"
                  />
                </svg>
                <span className="uppercase text-[#292D32] text-[12px]">
                  Suspended
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="mt-1">
            <span className="font-bold text-2xl">$</span>
            <span className="text-4xl font-bold">1.99 </span>
            <span className="mb-3 text-[#292D32] font-medium"> /Animal</span>
          </div>
        </div>
      </div>
    </div>
  );
};
